module.exports = __webpack_public_path__ + "static/media/thumbs-up.908d0675.png";